import { type RefObject, useEffect } from 'react';

type TFocusProps = {
  condition?: boolean;
  ref: RefObject<HTMLElement | null>;
};

export const useFocus = (props: TFocusProps) => {
  const { condition = false, ref } = props;

  useEffect(() => {
    if (condition) ref?.current?.focus();
  }, [condition, ref]);
};
